import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  getPharmacyMetricThresholdByCompanyIdData,
  setKpiServiceCountData,
  setKpiServiceColorData,
  setIsRefreshAvailableData,
  updatePharmacyMetricThresholdData,
  getCompanyMetricVisibilityData,
  upsertCompanyMetricVisibilityData,
  refreshPharmacyMetricThresholdData,
  checkRefreshStatusData,
} from "../features/dashboardKPISlice/dashboardKPISlice";

const reducerName = "dashboardKPI";

// #region State Setters
export const setKpiServiceCount = (count) => {
  dispatch(setKpiServiceCountData(count));
};
export const setKpiServiceColor = (color) => {
  dispatch(setKpiServiceColorData(color));
};
export const setIsRefreshAvailable = (value) => {
  dispatch(setIsRefreshAvailableData(value));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getPharmacyMetricThresholdByCompanyId = async (companyID) => {
  let result = [];
  try {
    result = await dispatch(
      getPharmacyMetricThresholdByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const updatePharmacyMetricThreshold = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePharmacyMetricThresholdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const getCompanyMetricVisibility = async (companyID) => {
  let result = [];
  try {
    result = await dispatch(getCompanyMetricVisibilityData(companyID)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const upsertCompanyMetricVisibility = async (data) => {
  let result = null;
  try {
    result = await dispatch(upsertCompanyMetricVisibilityData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const refreshPharmacyMetricThreshold = async (data) => {
  let result = null;
  try {
    result = await dispatch(refreshPharmacyMetricThresholdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const checkRefreshStatus = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(checkRefreshStatusData(companyID)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

// #endregion
